module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av180-98c7b3c512f61188e6e9984bd03e60be.jpg";